/**
 * Backend may send skill scores as 0–10 or 0–100 (values strictly greater than 10
 * are treated as a 0–100 scale for bar width and radar; display stays out of 10).
 */
export function skillScoreRawToOutOf10(raw: number | undefined, fallback: number): number {
  const n = raw ?? fallback;
  if (n > 10) return Math.min(10, n / 10);
  return Math.min(10, Math.max(0, n));
}

export function skillScoreRawToBarPct(raw: number | undefined, fallback: number): number {
  const n = raw ?? fallback;
  if (n > 10) return Math.min(100, Math.max(0, n));
  return Math.min(100, Math.max(0, n * 10));
}

export function skillScoreRawToRadarValue(raw: number | undefined, fallback: number): number {
  return skillScoreRawToBarPct(raw, fallback);
}
